import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { type MetricSummary } from '@/types'
import { storeRegistry } from '@/store/storeRegistry'



const defaultMetricSummary: MetricSummary = {
  tenant: {
    id: "",
    completed: "0",
    failed: "0",
    inFlight: "0",
    allocated: null,
    remaining: null,
    available: null,
    unlimited: true
  },
  user: {
    id: "",
    completed: "0",
    failed: "0",
    inFlight: "0",
    allocated: null,
    remaining: null,
    available: null,
    unlimited: true,
    fileCount: "0",
    validationCount: "0",
    validationsInFlight: "0"
  },
  subscription: {},
  diagnostics: {},
  lastFetch: 0,
  userId: "",
  loading: true
};


export const useMetricSummaryStore = defineStore('metricSummary', () => {
  // Initialize metricSummaryData as an empty reactive object.
  const data = reactive<MetricSummary>({ ...defaultMetricSummary } as MetricSummary)

  // Clear the metrics by resetting properties.
  function clearCacheStore() {
    Object.assign(data, defaultMetricSummary)
  }


  // Load the store's data from a given MetricSummary object.
  function saveToCacheStore(metrics: MetricSummary) {
    metrics.loading = false
    metrics.lastFetch = Date.now()
    Object.assign(data, metrics)
    
  }

  function resetStore() {
    clearCacheStore()
  }

  storeRegistry.register('metricSummary', resetStore)

  return { data, clearCacheStore, saveToCacheStore, resetStore };

})


